import { DashboardViewType } from '@shared/enums/dashboard-view-type';

export const propertySelectorTypes: DashboardViewType[] = [
  DashboardViewType.PROPERTY_VIEW,
  DashboardViewType.PROPERTY_WITH_GROUPING_VIEW,
  DashboardViewType.PROPERTY_WITHOUT_ALL,
];

export const allPropertyValue = -1;
export const portfolioAllPropertyValue = -2;
export const allPropertiesOption = {
  value: allPropertyValue,
  label: 'All properties',
  sort: 0,
};
export const allPortfoliosValue = -1;
export const allPortfoliosOption = {
  value: allPortfoliosValue,
  label: 'All portfolios',
  sort: 0,
};

export const ASSIGNEE_OPTION_UNASSIGNED_VALUE = -1;
export const ASSIGNEE_OPTION_UNASSIGNED = {
  sort: 2,
  value: ASSIGNEE_OPTION_UNASSIGNED_VALUE,
  label: 'Unassigned',
};
